import * as SecureStore from 'expo-secure-store';
import { Platform } from 'react-native';

const ACCESS_TOKEN_KEY = 'dengfeng.auth.access-token';

const secureStoreOptions =
  Platform.OS === 'ios'
    ? {
        keychainAccessible: SecureStore.WHEN_UNLOCKED_THIS_DEVICE_ONLY,
      }
    : undefined;

const getWebSessionStorage = (): Storage | null => {
  if (typeof globalThis === 'undefined' || !('sessionStorage' in globalThis)) {
    return null;
  }
  return globalThis.sessionStorage;
};

export const getStoredAuthToken = async (): Promise<string | null> => {
  if (Platform.OS === 'web') {
    try {
      return getWebSessionStorage()?.getItem(ACCESS_TOKEN_KEY) ?? null;
    } catch {
      return null;
    }
  }
  return SecureStore.getItemAsync(ACCESS_TOKEN_KEY);
};

export const setStoredAuthToken = async (accessToken: string): Promise<void> => {
  if (Platform.OS === 'web') {
    const storage = getWebSessionStorage();
    if (!storage) {
      throw new Error('Browser session storage is unavailable');
    }
    storage.setItem(ACCESS_TOKEN_KEY, accessToken);
    return;
  }
  await SecureStore.setItemAsync(ACCESS_TOKEN_KEY, accessToken, secureStoreOptions);
};

export const clearStoredAuthToken = async (): Promise<void> => {
  if (Platform.OS === 'web') {
    try {
      getWebSessionStorage()?.removeItem(ACCESS_TOKEN_KEY);
    } catch {
      // The browser may deny storage access; there is no persisted token to clear then.
    }
    return;
  }
  await SecureStore.deleteItemAsync(ACCESS_TOKEN_KEY);
};
